import {helpers} from '@/ft-vue-core'
import moment from 'moment'
import {defaultSearchFilter} from '../util/defaults'

const {setItems, deepClone, getGlobalValue} = helpers

export default {
  methods: {
    coversButtonColor (item) {
      const noShows = item.noShows
      if (item.covers - noShows < 1) return 'error'
      if (noShows) return 'warning'
      return 'success'
    },
    sameMonthDayInt (stringDate, intDate) {
      return moment(stringDate).format('MMDD') === (intDate + '').slice(-4)
    },
    onMemberPreferenceChange () {
      if (!this.showItem) this.refreshList()
    },
    getNameFromDetail (detail) {
      const guestType = this.guestTypeMap[detail.guestTypeId]
      if (!guestType) {
        return detail.memberId ? detail.name || 'Name Lookup Error' : 'Unknown'
      } else if (this.$ftCS.DINING_RES_LIST_SHOW_GUEST_NAMES && guestType.name && detail.name) {
        return detail.name + ' (' + guestType.name + ')'
      } else {
        return guestType.name || 'TBD'
      }
    },
    getReserveesForList (reservation) {
      const maxResult = this.$ftCS.DINING_RES_LIST_MAX_NAMES
      const result = []
      if (!reservation.details) return result
      const details = reservation.details.filter(d => !d.isPlaceholder && (!reservation.cancelled && !d.cancelled || reservation.cancelled === d.cancelled))
      if (!details.length) return result
      if (!reservation.discreteCovers) {
        const suffix = details.length > 1 ? ' + ' + (details.length - 1) : ''
        result.push({
          name: this.getNameFromDetail(details[0]) + suffix
        })
        return result
      }
      var lastResult
      var name
      var d
      var i = 0
      for (let detail of details) {
        i++
        name = this.getNameFromDetail(detail)
        if (lastResult && name === lastResult.name) {
          lastResult.count++
        } else {
          if (i > maxResult - 1 && details.length > maxResult) {
            result.push({
              name: '+ ' + (details.length - (i - 1)) + ' more',
              count: 1
            })
            break
          }
          d = {
            name: name,
            count: 1
          }
          lastResult = d
          result.push(d)
        }
      }
      return result
    },
    itemRowClass (item, index) {
      const classes = {
        'ft-cancelled-item': !!item.cancelled,
        'warning ft-darken-hover': !!item.issues,
        'ft-member-orig': !!item.origMemberId
      }
      return classes
    },
    getReservationIdListIcon (item) {
      /*
      if (item.cancelled) {
        return 'mdi-close-circle-outline'
      }
      */
      return null
    },
    getReservationIdListIconColor (item) {
      /*
      if (item.cancelled) {
        return 'error'
      }
      */
      return
    },
    getDefaultSearchFilter () {
      const dsf = deepClone(defaultSearchFilter)
      if (this.showWaitlist) {
        dsf.listingSortOrderId = 3 // Created, Oldest First
      }
      if (this.showColumns) {
        for (let key in this.showColumns) {
          dsf.columns[key] = this.showColumns[key]
        }
      }
      return dsf
    },
    clearSearchFilter () {
      setItems(this.searchFilter, this.getDefaultSearchFilter())
    },
    hasPropListFilters () {
      for (let key in this.propListFilter) {
        let val = this.propListFilter[key]
        if (val !== undefined && val !== null) return true
      }
      return false
    },
    getSavedListSearchFilter () {
      const listFilters = getGlobalValue(this.getSavedSearchFilterId(), this.searchFilterName)
      var hasPropFilters = this.hasPropListFilters()
      if (!this.showItem) console.log('Enable list loading')
      this.loadedSearchFilters = !this.showItem
      // Use props for filter if any?
      if (hasPropFilters && (!listFilters || !this.propListFilter.searchFilterId)) {
        const result = deepClone(this.getDefaultSearchFilter())
        for (let key in this.propListFilter) {
          let val = this.propListFilter[key]
          if (val !== undefined && val !== null) this.$set(result, key, val)
        }
        console.log('Applied Prop Filters', this.propListFilter, result)
        return result
      }
      // Load saved list filter for this route, if any
      if (listFilters) {
        const result = deepClone(listFilters)
        const defaultFilters = this.getDefaultSearchFilter()
        if (!result.days) {
          result.days = deepClone(defaultFilters.days)
        }
        if (!result.mealPeriodIds && result.mealPeriodId) {
          result.mealPeriodIds = [result.mealPeriodId]
        }
        if (!result.columns) {
          result.columns = deepClone(defaultFilters.columns)
        } else {
          for (let key in defaultFilters.columns) {
            if (result.columns[key] === undefined) {
              result.columns[key] = defaultFilters.columns[key]
            }
          }
        }
        return result
      } else {
        return deepClone(this.getDefaultSearchFilter())
      }
    },
    getSavedSearchFilterId () {
      return this.$route.fullPath
    },
    allowedFilterDates (val) {
      if (this.selectedEventsFilter && this.selectedEventsFilter.length) {
        return !!this.selectedEventsFilter.find(e => e.date === moment(val).format('YYYY-MM-DD'))
      }
      return true
    },
    getListExpandIcon (props) {
      const item = props.item
      return (this.hasAllergies(item) ? this.$ftStyle.reservation.allergyIcon : null) ||
      (this.hasSpecialOccasion(item) ? 'mdi-gift' : null) ||
      (this.hasSpecialRequests(item) ? 'mdi-message-text' : null) ||
      (this.hasHiddenRequests(item) ? 'mdi-message-outline' : null)
    },
    getListExpandIconColor (props) {
      const item = props.item
      return this.hasAllergies(item) ? this.$ftStyle.reservation.allergyColor : null
    },
    hasAllergies (item) {
      return !!item.details.find(d => d.member && d.member.allergyInformation)
    },
    hasSpecialOccasion (item) {
      return !!item.occasionId
    },
    hasSpecialRequests (item) {
      return !!item.memberSpecialRequests ||
        !!item.details.find(d => d.member && d.member.diningSpecialRequests)
    },
    hasHiddenRequests (item) {
      return !!item.specialRequests
    },
    toggleMealPeriods (mpIds) {
      const mpSelected = this.searchFilter.mealPeriodIds
      const mpMap = mpIds.reduce((a, m) => {a[m] = true; return a}, {})
      const mpsMap = mpSelected.reduce((a, m) => {a[m] = true; return a}, {})
      const notAll = mpIds.find(m => !mpsMap[m])
      if (notAll) {
        this.searchFilter.mealPeriodIds = mpSelected.filter(m => !mpMap[m]).concat(mpIds)
      } else {
        this.searchFilter.mealPeriodIds = mpSelected.filter(m => !mpMap[m])
      }
    },
    beforeLoadData () {
      return this.loadedSearchFilters && !this.showItem
    },
    onRouteChange () {
      console.log('RESERVATION LIST ROUTE CHANGED', this.$route.fullPath, this.showItem)
      this.loadedSearchFilters = false
      this.searchFilter = this.getSavedListSearchFilter()
    },
    addEditItemQueryFilter (query, id) {
      const searchFilter = this.searchFilter
      const selectedEvent = this.selectedEventFilter
      const selectedDate = searchFilter.date
      const selectedMealPeriods = this.selectedMealPeriodsFilter
      if (!id && (selectedEvent || selectedDate)) {
        // Use one-click reservation instead
        delete query.showId // remove empty showId that triggers new reservation
        delete query[this.showIdQuery] // remove showId trigger
        setTimeout(() => {this.showingItem = false}, 100) // clear showing item flag in a bit
        query.ocrId = '' // Set new one click reservation
        if (selectedEvent) {
          // new event reservation
          query.ocrEventId = selectedEvent.id
        } else {
          // new mp reservation
          query.ocrD = selectedDate
          if (selectedMealPeriods && selectedMealPeriods.length) {
            query.ocrLId = selectedMealPeriods[0].locationId
          }
        }
        if (searchFilter.locationId) {
          query.ocrLId = searchFilter.locationId
        }
      }
      return query
    }
  }
}
